module.exports = __webpack_public_path__ + "static/media/resetpassword.18976e8f.svg";